import { ModalConfirm } from '@direct-frontend/components';
import { successSrc } from '#shared/assets';
import { renderTemporaryComponent } from '#shared/lib/dom';

type LitePublishSuccessModalProps = {
    onClose: VoidFunction;
};

export function LitePublishSuccessModal({ onClose }: LitePublishSuccessModalProps) {
    return (
        <ModalConfirm
            isOpen
            onClose={onClose}
            imageSrc={successSrc}
            headerText="Товары станут доступны в Поиске и Алисе AI после проверки"
            bodyText="Проверка может занять до 1 дня"
            buttons={[
                {
                    color: 'accent',
                    text: 'Отлично!',
                    onClick: onClose,
                },
            ]}
        />
    );
}

export const showLitePublishSuccessModal = () =>
    renderTemporaryComponent((unmount) => <LitePublishSuccessModal onClose={unmount} />);
